export const loader = {
  color: 'primary',
  width: 'xl',
  height: 'xl',
};
